import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, PinReset) {
        this.$state = $state;
        this.Alert = Alert;
        this.PinReset = PinReset;
    }

    $onInit() {
        this.reset();
    }

    goBack() {
        this.$state.go('public.sms-user-otp');
    }

    reset() {
        this.confirmPin = '';
        this.pinReset = {phoneNumber: '', resetPin: '', pin: ''};
    }

    save() {
        this.PinReset.save(this.pinReset).$promise.then(
            () => this.$state.go(
                'public.sms-user-otp',
                {showResetPinSuccessMessage: true}
            ),
            ({data}) => {
                this.spAlert = new SpAlert('danger', data.message);
                this.reset();
            }
        )
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/pin-reset/pin-reset.controller.js